import React from "react";
import { H2_BANNER_SHAPE03 } from "../../lib/assets";
import bannerBg from "../../assets/img/banner-two/banner-bg.jpg";
import bannerImg from "../../assets/img/banner-two/banner-img.jpg";
import bannerShape01 from "../../assets/img/banner-two/banner-shape01.png";
import bannerShape02 from "../../assets/img/banner-two/banner-shape02.png";
import bannerShape03 from "../../assets/img/banner-two/Blue_circle.png";
import { Link } from "react-router-dom";
import { VideoPlayerOne } from "../VideoPlayers/VideoPlayerOne";

export const BannerTwo = () => {
  return (
    <>
      <section
        className="banner-area-two banner-bg-two"
        style={{ backgroundImage: `url(${bannerBg})` }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="banner-content-two">
                <span
                  className="sub-title"
                  data-aos="fade-up"
                  data-aos-delay="0"
                >
                  Bookkeeping for Startups & Small Businesses in Surrey, BC
                </span>
                <h2 className="title" data-aos="fade-up" data-aos-delay="300">
                Starting a Business? Stop Stressing About Bookkeeping.
                </h2>
                <p data-aos="fade-up" data-aos-delay="500">
                Not sure how to do your books, what it costs, or which software to use? Silverwave sets everything up and does your 
                bookkeeping every month for one flat fee, so you can focus on growing your business.
                </p>
                <div className="banner-btn">
                  <Link
                    to="/services"
                    className="btn"
                    data-aos="fade-right"
                    data-aos-delay="700"
                  >
                    Book a Free Health Check
                  </Link>

                  <VideoPlayerOne
                    src="https://www.youtube.com/embed/XMWYZ-uZjnQ"
                    text="See Pricing"
                    data-aos="fade-left"
                    data-aos-delay="700"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="banner-img text-center">
                <img
                  src={bannerImg}
                  alt=""
                  data-aos="fade-left"
                  data-aos-delay="400"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="banner-shape-wrap">
          <img src={bannerShape01} alt="" />
          <img src={bannerShape02} alt="" />
          <img
            src={bannerShape03}
            alt=""
            data-aos="zoom-in-up"
            data-aos-delay="800"
          />
        </div>
      </section>
    </>
  );
};
